export default [
    {
    text: "Actions",
    value: "actions",
    width: "80px",
    sortable: false,
    order: 1,
    hidable: false,
    hidden: false,
  },
  {
    text: "Name",
    value: "firstName",
    width: "250px",
    sortable: true,
    order: 1,
    hidable: false,
    hidden: false,
  },

  {
    text: "Email",
    value: "email",
    sortable: false,
    order: 2,
    hidable: true,
    hidden: false,
  },

  {
    text: "Join Date",
    value: "joinDate",
    width: "150px",
    sortable: true,
    order: 3,
    hidable: true,
    hidden: false,
  },

];
